"use client";

import React, { useState } from 'react'
import { useRouter, useSearchParams } from 'next/navigation'

function SortDesktop() {
  const router = useRouter()
  const searchParams = useSearchParams()
  const currentSort = searchParams?.get('sort') || ''

  const [optimisticSort, setOptimisticSort] = useState(currentSort)

  const sortOptions = [
    { value: "-hasPrice,-posted", label: "Posted Newest" },
    { value: "-hasPrice,posted", label: "Posted Oldest" },
    { value: "-hasPrice,price", label: "Price Lowest" },
    { value: "-hasPrice,-price", label: "Price Highest" },
  ];

  const handleSortChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newSort = event.target.value
    setOptimisticSort(newSort)
    if (searchParams) {
      const newSearchParams = new URLSearchParams(searchParams.toString())
      newSearchParams.set('sort', newSort)
      router.push(`?${newSearchParams.toString()}`)
    }
  }

  return (
    <select 
      className="hidden sm:inline-flex select select-bordered select-sm w-full max-w-xs p-0 pl-2"
      onChange={handleSortChange}
      value={optimisticSort}
    >
      <option value="" disabled>
        Sort by
      </option>
      {sortOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  )
}

export default SortDesktop